//IMPORTANT: Actions need to have defined type

export const ADD_NEW_AD_RULE = 'ADD_NEW_AD_RULE';
export const CLEAR_LOGS = 'CLEAR_LOGS';
export const IMPORT_SETTINGS = 'IMPORT_SETTINGS';
export const RELOAD_PLAYER = 'RELOAD_PLAYER';
export const REMOVE_AD_RULE = 'REMOVE_AD_RULE';
export const RESET_DATA = 'RESET_DATA';
export const SET_SSAR = 'SET_SSAR';
export const START_TEST = 'START_TEST';
export const UPDATE_ACTIVE_SECTION = 'UPDATE_ACTIVE_SECTIONS';
export const UPDATE_AD_BREAK = 'UPDATE_AD_BREAK';
export const UPDATE_AD_RULES = 'UPDATE_AD_RULES';
export const UPDATE_AD_RULE = 'UPDATE_AD_RULE';
export const UPDATE_CONFIGURATION = 'UPDATE_CONFIGURATION';
export const UPDATE_LOGS = 'UPDATE_LOGS';
export const UPDATE_PLACEMENT_DATA = 'UPDATE_PLACEMENT_DATA';
export const UPDATE_BANNER_DATA = 'UPDATE_BANNER_DATA';
export const UPDATE_OTHER_SETTINGS = 'UPDATE_OTHER_SETTINGS';
export const UPDATE_SUB_TAB = 'UPDATE_SUB_TAB';
export const UPDATE_VAST_FOR_INSPECT = 'UPDATE_VAST_FOR_INSPECT';
export const UPDATE_IMPORT_POPUP = 'UPDATE_IMPORT_POPUP';
export const UPDATE_COMPANION_SLOT = 'UPDATE_COMPANION_SLOT';
export const UPDATE_VAST_CONFIGURATION_URL = 'UPDATE_VAST_CONFIGURATION_URL';
export const POST_CONFIGURATION_REQUEST = 'POST_CONFIGURATION_REQUEST';
export const POST_CONFIGURATION_SUCCESS = 'POST_CONFIGURATION_SUCCESS';
export const POST_CONFIGURATION_FAILURE = 'POST_CONFIGURATION_FAILURE';
export const REGISTER_PLUGIN = 'REGISTER_PLUGIN';
export const FETCH_CONFIGURATION_SUCCESS = 'FETCH_CONFIGURATION_SUCCESS';

// Action creators for Section Panel actions
export const resetData = () => ({
  type: RESET_DATA,
});
export const setSsar = active => ({
  type: SET_SSAR,
  active,
});
export const startTest = () => ({
  type: START_TEST,
});
export const updateActiveSection = index => ({
  type: UPDATE_ACTIVE_SECTION,
  index,
});
export const updateSubTab = index => ({
  type: UPDATE_SUB_TAB,
  index,
});

// Action creators for Vast Inspector actions
export const updateVastForInspect = vastSource => ({
  type: UPDATE_VAST_FOR_INSPECT,
  vastSource,
});

// Action creators for Placement Data
export const updatePlacementData = data => ({
  type: UPDATE_PLACEMENT_DATA,
  data,
});

// Action creators for Banner Data
export const updateBannerData = data => ({
  type: UPDATE_BANNER_DATA,
  data,
});

// Action creators for Other Settings
export const updateOther = data => ({
  type: UPDATE_OTHER_SETTINGS,
  data,
});

// Action creators for Plugin Settings
export const updateConfiguration = data => ({
  type: UPDATE_CONFIGURATION,
  data,
});

// Action creators for Ad Rules
export const addNewAdRule = () => ({
  type: ADD_NEW_AD_RULE,
});
export const removeAdRule = index => ({
  type: REMOVE_AD_RULE,
  index,
});
export const updateAdBreak = data => ({
  type: UPDATE_AD_BREAK,
  data,
});
export const updateAdRule = data => ({
  type: UPDATE_AD_RULE,
  data,
});

// Action creators for Player Selection Panel
export const reloadPlayer = (name, version) => ({
  type: RELOAD_PLAYER,
  name,
  version,
});

//register plugin when the page is loaded
export const registerPlugin = () => ({
  type: REGISTER_PLUGIN,
});

// Action creators for Logs Panel
export const clearLogs = () => ({
  type: CLEAR_LOGS,
});
export const updateLogs = logs => ({
  type: UPDATE_LOGS,
  logs,
});

//Action for Import Settings
export const importSettings = data => ({
  type: IMPORT_SETTINGS,
  data,
});
export const updateImportPopup = data => ({
  type: UPDATE_IMPORT_POPUP,
  data,
});

//Actions for Companions
export const updateCompanionSlot = data => ({
  type: UPDATE_COMPANION_SLOT,
  data,
});

// Actions for shareable configuration URL
export const postConfigurationRequest = () => ({
  type: POST_CONFIGURATION_REQUEST,
});

export const postConfigurationSuccess = url => ({
  type: POST_CONFIGURATION_SUCCESS,
  url,
});

export const postConfigurationFailure = message => ({
  type: POST_CONFIGURATION_FAILURE,
  message,
});

export const fetchConfigurationSuccess = data => ({
  type: FETCH_CONFIGURATION_SUCCESS,
  data,
});

export const updateVastConfigurationUrl = vastSource => ({
  type: UPDATE_VAST_CONFIGURATION_URL,
  vastSource,
});
